import {Input, DatePicker } from "antd";
import {SearchOutlined} from "@ant-design/icons";

import styles from "./dashboard-search.module.scss";
import moment from "moment";

const { RangePicker } = DatePicker;

const dateFormat = 'YYYY/MM/DD';

function disabledDate(current) {
    // Can not select days before today and today
    return current && current > moment().endOf('day');
}

const DashboardSearch = ({onChange}) => {

    return (
        <>
            {/*<Input className={`${styles.field} ${styles.searchField}`} placeholder="Name, E-mail, Phone"*/}
            {/*       suffix={<SearchOutlined className={styles.searchIcon}/>}/>*/}
            <RangePicker disabledDate={disabledDate} onChange={onChange}  />
        </>
    )
}

export default DashboardSearch;
